var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"stylex":{paddingLeft: '320px'}}},[_c('Content',{style:({ backgroundColor: '#fff', minHeightx: '600px', width: '100%', marginTop: '60px', marginBottomXXXForFotter: '100px', padding: '20px 25px'})},[_c('Monitoring')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }